export default __webpack_public_path__ + "static/media/flutter_logo.62e03f4a.svg";